import React from 'react';
import { Form, FloatingLabel, Button } from 'react-bootstrap';
import { BsTrash } from 'react-icons/bs';

interface TicketPriceFormProps {
    ticket_group_code: string;
    ticket_notes: string;
    items: Item[];
    tier: string[];
    currency: string;
    amount: string[];
    onTicketNotesChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onTicketGroupCodeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    onTierChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    onCurrencyChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onAmountChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    onAddMore: () => void;
    onDelete: (index: number) => void;
}

interface Item {
    ticket_id: number;
    ticket_group_code: string;
    ticket_notes: string;
    // Add more properties as per your item structure
}

export default function TicketPriceForm({
    items,
    ticket_group_code,
    ticket_notes,
    tier,
    currency,
    amount,
    onTicketNotesChange,
    onTicketGroupCodeChange,
    onTierChange,
    onCurrencyChange,
    onAmountChange,
    onAddMore,
    onDelete,
}: TicketPriceFormProps) {
    return (
        <>
            <Form.Group className="mb-3">
                <Form.Label className="text-sm mb-2">Ticket Group Code</Form.Label>
                <Form.Select aria-label="Select Category" className='bg-gray-200 py-3' value={ticket_group_code} onChange={onTicketGroupCodeChange}>
                    <option value=""> Select Ticket Group Code</option>
                    {items.map((item) => (
                        <option key={item.ticket_id} value={item.ticket_group_code}>
                            {item.ticket_group_code}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label className="text-sm mb-2">Currency</Form.Label>
                <FloatingLabel controlId="floatingInput" label="Currency" className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Currency"
                        value={currency}
                        className='bg-gray-200'
                        onChange={onCurrencyChange}
                    />
                </FloatingLabel>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label className="text-sm mb-2">Ticket Notes</Form.Label>
                <FloatingLabel controlId="floatingInput" label="Ticket Notes" className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Ticket Notes"
                        value={ticket_notes}
                        className='bg-gray-200'
                        onChange={onTicketNotesChange}
                    />
                </FloatingLabel>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label className="text-sm mb-2">Tiers and Amounts</Form.Label>
                {tier.map((t, index) => (
                    <div key={index} className="d-flex align-items-center mb-3">
                        <Form.Control
                            type="text"
                            placeholder="Tier"
                            value={tier[index]}
                            onChange={(e) => onTierChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                            className="bg-gray-200 me-2"
                        />
                        <Form.Control
                            type="text"
                            placeholder="Amount"
                            value={amount[index]}
                            onChange={(e) => onAmountChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                            className="bg-gray-200 me-2"
                        />
                        <Button variant="secondary" onClick={() => onDelete(index)}>
                            <BsTrash />
                        </Button>
                    </div>
                ))}
                <div>
                    <Button variant="danger" onClick={onAddMore}>
                        Add More
                    </Button>
                </div>
            </Form.Group>
        </>
    );
}